<p>consolidated-report works!</p>
